import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

const pinia = createPinia();

const app = createApp(App);

app.config.errorHandler = (err, vm, info) => {
    console.log(err, vm, info)
}

app.use(pinia).use(router).use(Quasar, quasarUserOptions).mount('#app');

// eslint-disable-next-line
// app.provide("$msalInstance", () => { });


watch(
    pinia.state,
    (state) => {
        localStorage.setItem('piniaState', JSON.stringify(state))
    },
    { deep: true }
)
